import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import Icon from '../icon/Icon'
import Chosen from '../chosen/Chosen'

import './Pager.scss'

const perPageValues = [5, 10, 25, 50]

const Pager = ({
  className, currentPage, itemsPerPage, hideItemsPerPage, totalItems, ofLabel, itemsLabel, onChange,
  loadingNext,
  loadingPrev,
  disabled
}) => {
  const firstPage = (currentPage === 1)
  const lastPage = currentPage >= Math.ceil(totalItems / itemsPerPage)

  const startValue = (currentPage - 1) * itemsPerPage + 1
  const endValue = Math.min(currentPage * itemsPerPage, totalItems)

  const itemsPerPageOptions = perPageValues.map(o => ({ value: o, label: `${o} ${itemsLabel}` }))

  function goToPrev (e) {
    e.preventDefault()
    onChange({ pageNumber: currentPage - 1, pageSize: itemsPerPage })
  }

  function goToNext (e) {
    e.preventDefault()
    onChange({ pageNumber: currentPage + 1, pageSize: itemsPerPage })
  }

  function onPageSizeChange (v) {
    onChange({ pageNumber: 1, pageSize: parseInt(v.value) })
  }

  const prevBtnProps = {
    className: classnames('pager__prev', {
      'is-disabled': firstPage || disabled,
      'is-loading': loadingPrev
    }),
    disabled: firstPage,
    onClick: goToPrev
  }

  const nextBtnProps = {
    className: classnames('pager__next', {
      'is-disabled': lastPage || disabled,
      'is-loading': loadingNext
    }),
    disabled: lastPage,
    onClick: goToNext
  }

  const chosenPageSizeProps = {
    value: itemsPerPage,
    isSearchable: false,
    onChange: onPageSizeChange,
    options: itemsPerPageOptions,
    className: 'test-pager-PageSize chosenPageSize'

  }

  return (
    <div className={classnames('pager', className)}>
      <div className='pager__nav'>
        <button {...prevBtnProps}>
          {!loadingPrev && <Icon family='fa' icon='angle-left' />}
        </button>
        <p className='pager__counter'>{startValue} - {endValue} {ofLabel} {totalItems}</p>
        <button {...nextBtnProps}>
          {!loadingNext && <Icon family='fa' icon='angle-right' />}
        </button>
      </div>

      {!hideItemsPerPage &&
        <div className='pager__size_container'>
          {/* <select {...selectPageSizeProps}>
            {itemsPerPageOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select> */}
          <Chosen {...chosenPageSizeProps} />
        </div>}

    </div>
  )
}

Pager.defaultProps = {
  currentPage: 1,
  itemsPerPage: 10,
  hideItemsPerPage: false,
  totalItems: 0,
  ofLabel: 'of',
  itemsLabel: 'Items'
}

Pager.propTypes = {
  className: PropTypes.string,
  currentPage: PropTypes.number,
  itemsPerPage: PropTypes.number,
  hideItemsPerPage: PropTypes.bool,
  totalItems: PropTypes.number,
  ofLabel: PropTypes.node,
  itemsLabel: PropTypes.node,
  onChange: PropTypes.func
}

export default Pager
